export enum ScheduleStatus {
    Draft = "Draft",
    Published = "Published"
}